//

/**
 * Open the gallery at a certain image
 */
export const openGallery = (threadId, messageId) => {
  return {
    type: 'SHOW_GALLERY',
    isOpen: true,
    threadId,
    messageId,
  };
};

export const closeGallery = () => {
  return {
    type: 'HIDE_GALLERY',
  };
};
